import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import type { Environment } from '../../types/environment';

const endpoints = {
  production: 'https://communication-preferences.notonthehighstreet.com/anonymous',
  staging: 'https://communication-preferences.public.b.stag-eu-west-1.noths.com/anonymous',
  oldstaging: 'https://communication-preferences.public.b.prod-eu-west-1.noths.com/anonymous',
  qa: 'https://communication-preferences.qa.noths.com/anonymous',
  development: 'https://communication-preferences.qa.noths.com/anonymous',
};

export const communicationPreferences = async (env: Environment, address: string) => {
  const status = 'ENABLED';
  const channel = 'email';
  const source = 'NEWSLETTER';

  const fetchOptions = {
    timeout: 5000,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: { address, channel, status, source },
  };

  try {
    const response = await fetchJSONWithTimeout(`${endpoints[env]}`, fetchOptions);
    return response.ok;
  } catch (e) {
    const error = e as Error;
    return new Error(error.message);
  }
};
